import LocaleWebpackPlugin from './Plugin'
export = LocaleWebpackPlugin
